<template>
  <div class="wrapper_boxManager">
    <div class="monitor-header">区域信息</div>
    <div class="boxManager_table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="name" label="名称" align="center" />
        <el-table-column align="center" label="显示名称">
          <template slot-scope="scope">
            <div v-if="scope.row.showName === 0">隐藏</div>
            <div v-if="scope.row.showName === 1">显示</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button @click="locate(scope.row)" type="text" size="small"
              >定位</el-button
            >
            <el-button @click="checkDetail(scope.row.id)" type="text" size="small"
              >详情</el-button
            >
            <el-button @click="edit(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button @click="remove(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <br />
    <div class="boxManager_add">
      <el-button @click="drawBox" size="small">新标绘</el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import { mapMutations } from "vuex";
import {
  Viewer,
  Color,
  ScreenSpaceEventType,
  PolylineGlowMaterialProperty,
  Cartesian3,
  ScreenSpaceEventHandler,
  Entity,
  ImageMaterialProperty,
  CallbackProperty,
  Ion,
  Math as cesiumMath,
} from "cesium";
import cesiumUtil from "../../../utils/cesiumUtils";
import * as BoxData from "../../../api/BoxData";
import MapUtil from "@/views/control/map/util/mapUtil";
import CONSTANTS from "@/views/control/map/constants";
import Cesium from "cesium";
import {getPolice} from "@/api/worker";
import ECesium from "@/views/control/map/util/ECesium";
import {markLongitudeAndLatitude} from "../../../api/BoxData";

export default {
  data() {
    return {
      boxId: null,
      tableData: [],
      tooltip: null,
      V: null,
      tempNameCount: 10,
      polygonDrawing: null,
      positionDrawing: [],
      tempEntities: [],
      entitiesShow: true,
      allBoxEntitys: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      getter_currentAttributeDrawed: "getter_currentAttributeDrawed",
    }),
    allEntities() {
      return this.D3Config.Viewer.entities.values;
    },
  },
  methods: {
    ...mapActions({
      change_addBoxWindow_Visual: "change_addBoxWindow_Visual",
      change_currentEditedBox: "change_currentEditedBox",
      change_isAdd: "change_isAdd",
      toggleBoxDetailShow: "toggleBoxDetailShow",
      setBoxId: "setBoxId",
    }),
    //查看详情
    checkDetail(id) {
      // debugger
      this.setBoxId(id);
      this.toggleBoxDetailShow(true);
      MapUtil.closeOverlay();
    },

    /**
     * 地图打点设备位置
     * @param id
     */
    drawerDevicePoint(id){
      let self=this;
      MapUtil.closeOverlay();
      self.toggleBoxDetailShow(false);
      self.ECesiumTool = new ECesium.Tools(window.gisViewer);
      self.$parent.iconClick('区域');//关闭列表

      self.ECesiumTool.draw('Point', (position) => {
        let lonlat = cesiumUtil.Cartesian3_to_WGS84(position);
        MapUtil.closeOverlay();
        markLongitudeAndLatitude(id,lonlat[0],lonlat[1]).then(res => {
          const result = res.data;
          if (result.status_code === 100) {
            //self.getListData()
          }
          self.ECesiumTool.deactivate();
          self.$parent.iconClick('区域');//打开列表
          self.toggleBoxDetailShow(true);
        });
      });
    },

    getAll() {
      let _this=this;
      BoxData.getAllBox().then((res) => {
        let datas = res.data.data;
        _this.tableData = datas;
        _this.$nextTick(() => {
          _this.generateAllBox(_this.tableData);
        });
      });
    },
    edit(row) {
      this.change_isAdd({ info: 0 });
      this.change_addBoxWindow_Visual({ visual: true });
      //保存内容 包括当前实体，因为要更新高度和颜色
      let entityEdit;
      for (let i = 0; i < this.allEntities.length; i++) {
        if (
          this.allEntities[i].polygon &&
          row.name == this.allEntities[i].name
        ) {
          entityEdit = this.allEntities[i];
          break;
        }
      }

      let options = Object.assign(row, { entity: entityEdit });
      this.change_currentEditedBox({ info: options });
    },
    remove(row) {
      //移除罩子
      BoxData.deleteBox({
        id: row.id,
      }).then((res) => {
        //移除地图实体
        let entityRemoveing;
        for (let i = 0; i < this.allEntities.length; i++) {
          if (
            this.allEntities[i].polygon &&
            row.name == this.allEntities[i].name
          ) {
            entityRemoveing = this.allEntities[i];
            break;
          }
        }
        if (entityRemoveing) {
          this.D3Config.Viewer.entities.remove(entityRemoveing);
        } else {
        }
        this.getAll();
      });
    },
    locate(row) {
      let entities = this.D3Config.Viewer.entities;
      let entitiesValue = entities.values;
      let entityLocated;
      for (let i = 0; i < entitiesValue.length; i++) {
        if (entitiesValue[i].polygon && row.name == entitiesValue[i].name) {
          entityLocated = entitiesValue[i];
          break;
        }
      }
      if (entityLocated) {
        this.D3Config.Viewer.zoomTo(entityLocated);
      } else {
      }
    },
    generateAllBox(data) {
      let self = this;
      self.fourColorLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.FOURCOLOR);//四色图图层
      self.workOrderLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.WORKORDER);//作业票图层
      self.deviceDataLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.DEVICEDATA);//设备数据图层
      self.fourColorLayer.clearLayer();
      data.forEach(function (_box, index) {
        let coors = [],
          options = {};
        for (let i = 0; i < _box.coors.length; i++) {
          let coor = _box.coors[i].coor;
          coors.push(Number(coor[0]));
          coors.push(Number(coor[1]));
        }
        options = {
          name: _box.name,
          showName:_box.showName,
          height: Number(_box.hight),
          grade: Number(_box.riskLevel),
        };
        // debugger;
        let boxEntity = cesiumUtil.createPolygon(coors, options);
        _box.layerName= self.fourColorLayer.layerName;
        //风险等级
        if(_box.riskLevel==0){
          _box.riskLevelStr="重大风险";
        }else if(_box.riskLevel==1){
          _box.riskLevelStr="较大风险";
        }else if(_box.riskLevel==2){
          _box.riskLevelStr="一般风险";
        }else if(_box.riskLevel==3){
          _box.riskLevelStr="低风险";
        }
        let lonlat=cesiumUtil.Cartesian3_to_WGS84(boxEntity.position._value);
        _box.longitude = lonlat[0];
        _box.latitude =lonlat[1];
        boxEntity.attributes=_box;
        self.allBoxEntitys.push(boxEntity);
        self.fourColorLayer.dataSource.entities.add(boxEntity);
      });
      self.workOrderLayer.addEntities(self.allBoxEntitys);
      window.boxCheckDetail=self.checkDetail;
      //轮询查询四色图上设备实时数据
      self.deviceDataSetInterval = setInterval(() => {
        BoxData.findSirenTimelyDataShowOnHood().then(res => {
          if (res.data.data.length > 0&&self.allBoxEntitys) {
            self.allBoxEntitys.map(item => {
              let deviceDataArr=res.data.data.filter(item1=>item1.mapDrawInfoId==item.attributes.id);
              if(deviceDataArr.length>0){
                item.attributes.deviceDataArr=deviceDataArr;
              }
            });
            self.deviceDataLayer.addEntities(self.allBoxEntitys);
          }
        });
      }, 3000)
    },
    drawBox() {
      // debugger;
      this.$parent.iconClick('区域')
      let that = this;
      this.createTooltip();
      var tempPoints = [],
        tempEntities = this.tempEntities;
      let handler = new ScreenSpaceEventHandler(that.V.scene.canvas);
      that.tooltip.style.display = "block";
      //鼠标移动事件
      handler.setInputAction(function (movement) {
        that.tooltip.style.left = movement.endPosition.x + 10 + "px";
        that.tooltip.style.top = movement.endPosition.y + 20 + "px";
      }, ScreenSpaceEventType.MOUSE_MOVE);
      //左键点击操作
      handler.setInputAction(function (click) {
        //调用获取位置信息的接口
        let position = that.V.camera.pickEllipsoid(
          click.position,
          that.V.scene.globe.ellipsoid
        );
        tempPoints.push(position);

        let tempLength = tempPoints.length;
        //调用绘制点的接口
        let point = that.drawPoint(position);

        tempEntities.push(point);
        if (tempLength > 1) {
          let pointline = that.drawPolyline([
            tempPoints[tempPoints.length - 2],
            tempPoints[tempPoints.length - 1],
          ]);
          tempEntities.push(pointline);
        } else {
          that.tooltip.innerHTML = "请绘制下一个点，右键结束";
        }
        return;
      }, ScreenSpaceEventType.LEFT_CLICK);
      //右键点击操作
      handler.setInputAction(function (click) {
        window.oncontextmenu = function (e) {
          e.preventDefault();
        };
        let mouse_pos = click.position;
        let cartesian = that.V.camera.pickEllipsoid(
          click.position,
          that.V.scene.globe.ellipsoid
        );
        if (cartesian) {
          let tempLength = tempPoints.length;
          if (tempLength < 3) {
            alert("请选择3个以上的点再执行闭合操作命令");
          } else {
            //闭合最后一条线
            let pointline = that.drawPolyline([
              tempPoints[tempPoints.length - 1],
              tempPoints[0],
            ]);
            tempEntities.push(pointline);
            that.createBox(tempPoints, mouse_pos);
            tempEntities.push(tempPoints);
            handler.destroy(); //关闭事件句柄
            handler = null; //销毁事件对象
            that.tooltip.style.display = "none"; //移除鼠标提示
          }
        }
      }, ScreenSpaceEventType.RIGHT_CLICK);
    },
    /**
     * 创建鼠标提示信息框
     */
    createTooltip() {
      // 提示框
      let tooltip = document.createElement("div");
      this.tooltip = tooltip;
      document.body.appendChild(tooltip);
      tooltip.width = "300";
      tooltip.height = "300";
      tooltip.style.display = "none";
      tooltip.style.position = "absolute";
      tooltip.innerHTML = `点击开始`;
    },
    /**
     * 画点
     */
    drawPoint(position, config) {
      var config = config ? config : {};
      var pointGeometry = this.V.entities.add({
        name: "点几何对象",
        position: position,
        point: {
          color: Color.SKYBLUE,
          pixelSize: 2,
          outlineColor: Color.YELLOW,
          outlineWidth: 1,
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
        },
      });
      return pointGeometry;
    },
    /**
     * 画线
     */
    drawPolyline(positions, config) {
      if (positions.length < 1) return;
      var config = config ? config : {};
      var polylineGeometry = this.V.entities.add({
        name: "线几何对象",
        polyline: {
          positions: positions,
          width: config.width ? config.width : 5.0,
          material: new PolylineGlowMaterialProperty({
            color: config.color
              ? new Color.fromCssColorString(config.color)
              : Color.GOLD,
          }),
          depthFailMaterial: new PolylineGlowMaterialProperty({
            color: config.color
              ? new Color.fromCssColorString(config.color)
              : Color.GOLD,
          }),
        },
      });
      return polylineGeometry;
    },
    /**
     * 画多边形
     */
    drawPolygon(positions) {
      if (positions.length < 2) return;
      let coors = [];
      for (let i = 0; i < positions.length; i++) {
        let lonlat = cesiumUtil.Cartesian3_to_WGS84(positions[i]);
        coors.push(lonlat[0]);
        coors.push(lonlat[1]);
      }

      var polygonGeometry = new Entity({
        name: "",
        polygon: {
          hierarchy: Cartesian3.fromDegreesArray(coors),
          extrudedHeight: 0.0,
        },
      });
      return polygonGeometry;
    },
    /**
     * 创建弹窗
     * @param {} position 鼠标最后点击位置
     */
    createSetAttrWindow(position) {
      let _wraper = document.createElement("div");
      _wraper.id = "SetAttrWindow";
      _wraper.classList.add("SetAttrWindow");
      _wraper.style.position = "absolute";
      _wraper.style.left = position.x + "px";
      _wraper.style.top = position.y + "px";
      _wraper.style.backgroundColor = "gray";
      _wraper.style.width = 200;
      _wraper.style.height = 200;
      _wraper.style.zIndex = "1000";
      document.body.appendChild(_wraper);
      _wraper.innerHTML = `
                <header class="SetAttrWindow_header">
                设置围墙高度和颜色
                </header>
                <main class="SetAttrWindow_main">
                <ul>
                    <li>
                    <select id="colorSelect">
                        <option value="1">红色</option>
                        <option value="2">绿色</option>
                        <option value="3">蓝色</option>
                        <option value="4">橙色</option>
                    </select>
                    </li>
                    <li>
                    <label>栏高度</label><input type="text" id="HighTxt" />        </li>
                    <li>
                    <input type="button" id="submit" value="确定" />
                    </li>
                </ul>
                </main>`;
    },

    /**
     * 生成罩子
     * @param {*} pos
     * @param {*} mousePos
     */
    createBox(pos, mousePos) {
      let that = this;
      this.polygonDrawing = this.drawPolygon(pos);
      this.positionDrawing = pos;
      //弹出新增窗口
      this.change_isAdd({ info: 1 });
      this.change_addBoxWindow_Visual({ visual: true });
    },
    //开启
    showBoxDraw() {
      this.V = this.D3Config.Viewer;
      let arr=this.allBoxEntitys;
      arr.forEach((entity)=>{
          //this.entitiesShow=!this.entitiesShow;
          entity.show=!entity.show;
      })
    },
    init() {
      this.getAll();
    },
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.V = this.D3Config.Viewer;
    }, 0);
  },
  watch: {
    getter_currentAttributeDrawed: {
      handler: function (newVal, oldVal) {
        let options = newVal;
        let that = this;
        let colorEnum = {
          3: Color.RED,
          2: Color.ORANGE,
          1: Color.YELLOW,
          0: Color.BLUE,
        };
        // this.polygonDrawing.polygon.extrudedHeight = Number(options.hight);
        // this.polygonDrawing.polygon.material = colorEnum[
        //   options.riskLevel
        // ].withAlpha(0.2);
        // this.polygonDrawing.name = options.name;
        // that.V.entities.add(this.polygonDrawing);
        // 绘制完之后 移除所有点和线
        that.V.entities.removeAll();
        //添加罩子
        let coors = "";
        for (let i = 0; i < that.positionDrawing.length; i++) {
          let lonlat = cesiumUtil.Cartesian3_to_WGS84(that.positionDrawing[i]);
          coors += `${lonlat[0]},${lonlat[1]};`;
        }
        options = Object.assign(options, {
          coor: coors,
        });

        let data = BoxData.addBox(options).then((res) => {
          that.getAll();
          that.change_addBoxWindow_Visual({ visual: false });
        });
      },
      deep: true,
    },
    //   tableData:{
    //       handler:function(newV,oldV){
    //         BoxData.getAllBox().then((res)=>{
    //             let datas=res.data.data;
    //             this.tableData=datas;
    //             debugger;
    //             this.generateAllBox(this.tableData);
    //             console.log("datas",datas);
    //         })
    //       },
    //       deep:true,
    //       immediate:true
    //   }
  },
  beforeDestroy() {
    this.deviceDataSetInterval&&clearInterval(this.deviceDataSetInterval);
  }
};
</script>
<style scoped>
.monitor-header {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #f5f5f5;
  margin-bottom: 15px;
}
.boxManager_table{
  padding: 0 15px 15px 15px;
}
.wrapper_boxManager {
  position: absolute;
  top: 15%;
  left: 20%;
  padding: 0;
  box-sizing: border-box;
  background: #fff;
  max-height: 60vh;
  overflow-y: scroll;
  border: 1px solid #ebeef5;
  width: 60%;
  height: 60%;
}
.boxManager_add {
  text-align: right;
}
</style>
